import { __extends, __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { Component, forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import '../../../reset/HtmlA/HtmlA.js';
import '../../../reset/HtmlButton/HtmlButton.js';
import { HtmlDiv } from '../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../reset/HtmlH/HtmlH.js';
import { HtmlInput } from '../../../reset/HtmlInput/HtmlInput.js';
import '../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../reset/HtmlLi/HtmlLi.js';
import '../../../reset/HtmlNav/HtmlNav.js';
import '../../../reset/HtmlOl/HtmlOl.js';
import '../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../reset/HtmlUl/HtmlUl.js';
import '../../../reset/HtmlTable/HtmlTable.js';
import '../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../reset/HtmlTable/HtmlTableCell.js';
import { AutoId } from '../../utils/AutoId/AutoId.js';
import { SuomifiThemeConsumer } from '../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../theme/SuomifiTheme/SuomifiTheme.js';
import '../../theme/SpacingProvider/SpacingProvider.js';
import { getConditionalAriaProp } from '../../../utils/aria/aria.js';
import { Label } from '../Label/Label.js';
import { HintText } from '../HintText/HintText.js';
import { StatusText } from '../StatusText/StatusText.js';
import { baseStyles } from './FilterInput.baseStyles.js';

var baseClassName = 'fi-filter-input';
var filterInputClassNames = {
  error: "".concat(baseClassName, "--error"),
  disabled: "".concat(baseClassName, "--disabled"),
  labelAlignLeft: "".concat(baseClassName, "--label-align-left"),
  labelIsVisible: "".concat(baseClassName, "_label--visible"),
  wrapper: "".concat(baseClassName, "_wrapper"),
  functionalityContainer: "".concat(baseClassName, "_functionalityContainer"),
  inputElementContainer: "".concat(baseClassName, "_input-element-container"),
  inputElement: "".concat(baseClassName, "_input"),
  actionElementsContainer: "".concat(baseClassName, "_action-elements-container"),
  statusTextHasContent: "".concat(baseClassName, "_statusText--has-content")
};
var BaseFilterInput = function (_super) {
  __extends(BaseFilterInput, _super);
  function BaseFilterInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.filterItems = function (items, filterFunc, value) {
      return items.reduce(function (filtered, item) {
        if (filterFunc(item, value)) {
          filtered.push(item);
        }
        return filtered;
      }, []);
    };
    return _this;
  }
  BaseFilterInput.prototype.componentDidUpdate = function (prevProps) {
    if (!!this.props.onFilter && prevProps.value !== this.props.value || prevProps.items !== this.props.items) {
      var value = !!this.props.value ? this.props.value.toString() : '';
      this.props.onFilter(this.filterItems(this.props.items, this.props.filterFunc, value));
    }
  };
  BaseFilterInput.prototype.render = function () {
    var _a, _b, _c;
    var _this = this;
    var _d = this.props,
      className = _d.className,
      inputContainerProps = _d.inputContainerProps,
      inputElementContainerProps = _d.inputElementContainerProps,
      visualPlaceholder = _d.visualPlaceholder,
      labelText = _d.labelText,
      labelMode = _d.labelMode,
      hintText = _d.hintText,
      optionalText = _d.optionalText,
      status = _d.status,
      statusText = _d.statusText,
      id = _d.id,
      labelAlign = _d.labelAlign,
      ariaDescribedBy = _d["aria-describedby"],
      _e = _d.statusTextAriaLiveMode,
      statusTextAriaLiveMode = _e === void 0 ? 'assertive' : _e;
      _d.items;
      _d.onFilter;
      _d.filterFunc;
      var forwardedRef = _d.forwardedRef,
      propOnChange = _d.onChange,
      children = _d.children,
      tooltipComponent = _d.tooltipComponent,
      passProps = __rest(_d, ["className", "inputContainerProps", "inputElementContainerProps", "visualPlaceholder", "labelText", "labelMode", "hintText", "optionalText", "status", "statusText", "id", "labelAlign", 'aria-describedby', "statusTextAriaLiveMode", "items", "onFilter", "filterFunc", "forwardedRef", "onChange", "children", "tooltipComponent"]);
    var onChangeHandler = function onChangeHandler(event) {
      var _a = _this.props,
        items = _a.items,
        onFilter = _a.onFilter,
        filterFunc = _a.filterFunc;
      var eventValue = event.target.value;
      var filteredItems = _this.filterItems(items, filterFunc, eventValue);
      onFilter(filteredItems);
      if (propOnChange) {
        propOnChange(eventValue);
      }
    };
    var labelId = "".concat(id, "-label");
    var hintTextId = hintText ? "".concat(id, "-hintText") : undefined;
    var statusTextId = statusText ? "".concat(id, "-statusText") : undefined;
    return /*#__PURE__*/React.createElement(HtmlDiv, __assign({}, inputContainerProps, {
      className: classnames(baseClassName, className, (_a = {}, _a[filterInputClassNames.disabled] = !!passProps.disabled, _a[filterInputClassNames.error] = status === 'error', _a[filterInputClassNames.labelAlignLeft] = labelAlign === 'left', _a))
    }), /*#__PURE__*/React.createElement(HtmlDiv, {
      className: classnames(filterInputClassNames.wrapper, {})
    }, /*#__PURE__*/React.createElement(Label, {
      id: labelId,
      labelMode: labelMode,
      optionalText: optionalText,
      className: classnames((_b = {}, _b[filterInputClassNames.labelIsVisible] = labelMode !== 'hidden', _b)),
      tooltipComponent: tooltipComponent,
      htmlFor: id
    }, labelText), /*#__PURE__*/React.createElement(HintText, {
      id: hintTextId
    }, hintText), /*#__PURE__*/React.createElement(HtmlDiv, {
      className: filterInputClassNames.functionalityContainer
    }, /*#__PURE__*/React.createElement(HtmlDiv, __assign({
      className: filterInputClassNames.inputElementContainer
    }, inputElementContainerProps), /*#__PURE__*/React.createElement(HtmlInput, __assign({}, passProps, {
      "aria-labelledby": labelId,
      "aria-invalid": status === 'error',
      id: id,
      className: filterInputClassNames.inputElement,
      type: "text",
      forwardedRef: forwardedRef,
      placeholder: visualPlaceholder
    }, getConditionalAriaProp('aria-describedby', [statusTextId, hintTextId, ariaDescribedBy]), {
      autoComplete: "off",
      "aria-autocomplete": "list",
      autoCapitalize: "none",
      spellCheck: "false",
      onChange: onChangeHandler,
      "aria-multiline": false
    }))), React.Children.count(children) > 0 && ( /*#__PURE__*/React.createElement(HtmlDiv, {
      className: filterInputClassNames.actionElementsContainer,
      onMouseDownCapture: function onMouseDownCapture(event) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, children)), /*#__PURE__*/React.createElement(StatusText, {
      id: statusTextId,
      className: classnames((_c = {}, _c[filterInputClassNames.statusTextHasContent] = !!statusText, _c)),
      status: status,
      disabled: passProps.disabled,
      ariaLiveMode: statusTextAriaLiveMode
    }, statusText))));
  };
  return BaseFilterInput;
}(Component);
var BaseFilterInputWrapper = function BaseFilterInputWrapper(_a) {
  _a.theme;
    var passProps = __rest(_a, ["theme"]);
  return /*#__PURE__*/React.createElement(BaseFilterInput, __assign({}, passProps));
};
var StyledFilterInput = styled(BaseFilterInputWrapper).withConfig({
  componentId: "sc-c0uaap-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return baseStyles(theme);
});
var FilterInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var propId = props.id,
    passProps = __rest(props, ["id"]);
  return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
    var suomifiTheme = _a.suomifiTheme;
    return /*#__PURE__*/React.createElement(AutoId, {
      id: propId
    }, function (id) {
      return /*#__PURE__*/React.createElement(StyledFilterInput, __assign({
        theme: suomifiTheme,
        id: id,
        forwardedRef: ref
      }, passProps));
    });
  });
});
FilterInput.displayName = 'FilterInput';
var templateObject_1;

export { FilterInput };
//# sourceMappingURL=FilterInput.js.map
